import { BaseEditViewStore, BaasicDropdownStore } from "core/stores";
import { DxCodeDropdownStore } from 'application/facility-order-new-flow-us-intake/stores';
import { FacilityOrderTemplateNewFlowClinicalEditForm } from 'application/facility-order-new-flow-clinical/forms';
import { action, observable, runInAction } from "mobx";
import _ from 'lodash';
import { uuid } from "core/utils";

class FacilityOrderTemplateNewFlowClinicalEditViewStore extends BaseEditViewStore {
    @observable accessor productStore;
    @observable accessor facilityOrderTemplate;
    @observable accessor isClinicalStatusNoteVisible = false;
    @observable accessor disabledItem = false;
    @observable accessor isSyncInProgress = false;
    @observable accessor missingDocsPreviousValue = null;
    @observable accessor templateExpanded = { id: null, expanded: false };
    @observable accessor showThirdRow = false;
    thirdRowStoresInitialized = false;
    @observable accessor isQtyChange = false;

    inactiveOptions = [{ id: "15", name: "Hospital" }, { id: "17", name: "Discharged" }, { id: "18", name: "Expired" }, { id: "0", name: "Active" }];
    constructor(rootStore, componentsProps) {
        const facilityOrderTemplate = componentsProps.item;
        const patient = componentsProps.patient;
        const pageViewStore = componentsProps.pageViewStore;
        super(rootStore, {
            name: 'facility-order-template-clinical-edit-modal',
            Form: FacilityOrderTemplateNewFlowClinicalEditForm,
            id: facilityOrderTemplate && facilityOrderTemplate.id,
            authorization: 'portalSection.update',
            actions: () => {
                return {
                    get: async () => {
                        return {
                            ...facilityOrderTemplate,
                            facilityOrderTemplateMissingDocuments: facilityOrderTemplate.facilityOrderTemplateMissingDocuments.map(i => ({ ...i.missingDocument, facilityOrderTemplateMissingDocumentId: i.id, note: i.note })),
                            height: patient.height,
                            weight: patient.weight
                        };
                    },
                    update: async (resource) => {
                        resource.facilityOrderTemplateMissingDocuments = resource.facilityOrderTemplateMissingDocuments && resource.facilityOrderTemplateMissingDocuments.map(i => { return { missingDocumentId: i.id, note: i.note } });
                        const response = await pageViewStore.facilityOrderTemplateService.updateNewFlowClinicalTemplate({ ...facilityOrderTemplate, ...resource });
                        return response.data;
                    },
                    updatePatientDetails: async (resource) => {
                        const response = await pageViewStore.patientService.updatePatientDetails(resource);
                        return response;
                    },
                }
            },
            FormClass: FacilityOrderTemplateNewFlowClinicalEditForm,
            autoInit: true
        });

        this.rootStore = rootStore;

        _.forEach(facilityOrderTemplate.facilityOrderTemplateItems, (facilityOrderTemplateItem) => {
            facilityOrderTemplateItem.lastTemplateQuantity = facilityOrderTemplateItem.templateQuantity;
            facilityOrderTemplateItem.lastOrderQuantity = facilityOrderTemplateItem.orderQuantity;
            facilityOrderTemplateItem.lastNote = facilityOrderTemplateItem.note;
        });
        this.facilityOrderTemplate = facilityOrderTemplate;
        this.patient = patient;

        this.pageViewStore = pageViewStore;
        this.selectedStatusAbrv = componentsProps.selectedStatusAbrv;
        this.facilityOrderId = componentsProps.facilityOrderId;
        this.reviewFacilityOrderTemplate = componentsProps.reviewFacilityOrderTemplate;
        this.initializePatientHeightAndWeight = componentsProps.initializePatientHeightAndWeight;
        this.isNewPatient = componentsProps.isNewPatient;
        this.facilityOrderPatient = componentsProps.facilityOrderPatient;
        this.missingDocuments = this.pageViewStore.missingDocuments;
        this.clinicalStatuses = this.pageViewStore.clinicalStatuses;
        this.doesNotMeetClinicalStatusId = this.clinicalStatuses.find(x => x.name === "Does Not Meet Insurance Criteria").id;
        this.diagnosisCode = componentsProps.diagnosisCode;

        this.fetchPatientTemplates = componentsProps.fetchPatientTemplates;
        this.setLinkedTemplate = componentsProps.setLinkedTemplate;
        this.removeTemplate = componentsProps.removeTemplate;
        this.lookups = componentsProps.lookups;
        this.deleteImportActionId = this.lookups.importAction.find(x => x.abrv == 'delete').id;
        this.facilityOrder = componentsProps.facilityOrder;
        this.isEligible = componentsProps.isEligible;
        this.checkIsEmpty = componentsProps.checkIsEmpty;
        this.isMasterPatient = this.facilityOrder.facility.masterPatientId == this.patient.patientKey;
        this.getNumberOfTemplates = componentsProps.getNumberOfTemplates;
        this.isImportAllowed = componentsProps.isImportAllowed;
        this.sendAgoraPo = this.facilityOrder.facility.sendAgoraPo;
        this.insertImportActionId = this.lookups.importAction.find((s) => s.abrv === 'insert').id;

        this.isMasterPatient = this.patient.patientKey ? (this.facilityOrder && this.facilityOrder.facility.masterPatientId == this.patient.patientKey) : false;

        this.clinicalStatusStore = new BaasicDropdownStore({}, {
            fetchFunc: async () => {
                return this.clinicalStatuses.filter(status =>
                    this.isMasterPatient
                        ? ["Emergency Stock", "Enfit Adapters", "Supplements", "Purchase Order", "Above Allowable Tubes"].includes(status.name)
                        : !["Emergency Stock", "Enfit Adapters", "Supplements", "Purchase Order", "Above Allowable Tubes"].includes(status.name)
                );
            },
            onChange: async () => {
                await this.updateFacilityOrderTempalte("clinicalStatusId", true);
            }
        });

        this.missingDocumentStore = new BaasicDropdownStore({ multi: true, filterable: true }, {
            fetchFunc: async (term = "") => {
                return this.filterMissingDocumentStore(this.missingDocuments.filter(mc => (mc.itemCategoryId === this.facilityOrderTemplate.subCategory.itemCategoryId || !mc.itemCategoryId) && mc.name.toLowerCase().includes(term.toLowerCase())));
            },
            onChange: async () => {
                await this.updateFacilityOrderTempalte("facilityOrderTemplateMissingDocuments", true);
            }
        });

        document.addEventListener('click', (e) => {
            if (!this.templateExpanded.id) return;
            const elements = [
                ...document.querySelectorAll(`[id="templateQuantity-${this.templateExpanded.id}"]`),
                ...document.querySelectorAll(`[id="orderQuantity-${this.templateExpanded.id}"]`),
            ];
            const clickedOutside = elements.length === 0 || elements.every((el) => !el.contains(e.target));
            if (clickedOutside) {
                this.templateExpanded.expanded = false;
            }
        });
    }

    @action
    async initialize() {
        if (this.isEdit) {
            await this.getResource(this.id);
            if (!this.facilityOrderTemplate.clinicalStatusId) {
                this.clinicalStatusStore.setValue({ id: null, name: "Select" });
            }
            this.missingDocsPreviousValue = this.getMissingDocsPreviousValue();
        } else {
            this.form.clear();
        }
    }

    @action
    async setItem(item) {
        this.item = item;
    }

    @action.bound
    async setDefaultStoreValue() {
        const codes = [
            this.facilityOrderTemplate.dxCode1,
            this.facilityOrderTemplate.dxCode2,
            this.facilityOrderTemplate.dxCode3,
            this.facilityOrderTemplate.dxCode4,
            this.facilityOrderTemplate.dxCode5,
            this.facilityOrderTemplate.dxCode6,
            this.facilityOrderTemplate.dxCode7,
            this.facilityOrderTemplate.dxCode8,
        ];
        const resolved = await Promise.all(codes.map(async (code) => {
            if (!code) return null;
            const response = await this.pageViewStore.diagnosisCodeService.find({ searchQuery: code, rpp: 10, itemCategoryId: this.facilityOrderTemplate && this.facilityOrderTemplate.itemCategoryId, isBillable: true });
            const match = response.data.item && response.data.item.find(x => x.code === code);
            return match || { code };
        }));
        for (let i = 0; i < resolved.length; i++) {
            this[`dxCode${i + 1}Store`].setValue(resolved[i]);
        }
    }

    @action.bound
    createDxCodeDropdownStore() {
        return new DxCodeDropdownStore(
            { filterable: true, dataItemKey: "code", textField: "code" },
            {
                fetchFunc: async (term) => {
                    if (!term || term.trim() === '') {
                        term = undefined;
                    }

                    const response = await this.pageViewStore.diagnosisCodeService.find({ searchQuery: term, rpp: 10, itemCategoryId: this.facilityOrderTemplate && this.facilityOrderTemplate.itemCategoryId, isBillable: true });
                    return response.data.item;
                },
                onChange: async () => {
                    await this.updateFacilityOrderTempalte("dxCode", true);
                }
            }
        );
    }

    @action.bound
    getSelectedInactiveOption() {
        if ((!this.facilityOrderTemplate.templateId || (this.facilityOrderTemplate.newFlowStatus.abrv === "new-order" && (this.facilityOrderTemplate.importDetailStatus.abrv === 'imported' || this.facilityOrderTemplate.importDetailStatus.abrv === 'failed'))) && (this.facilityOrderTemplate.inactiveReasonId != 15 && this.facilityOrderTemplate.inactiveReasonId != 17 && this.facilityOrderTemplate.inactiveReasonId != 18)) {
            return "new";
        }
        else if (this.facilityOrderTemplate.newFlowStatus.abrv === "change") {
            return "warning-triangle";
        }
        else if (this.facilityOrderTemplate.newFlowStatus.abrv === "no-change") {
            return "success";
        }
        else if (this.facilityOrderTemplate.newFlowStatus.abrv === "discharge") {
            return "danger";
        }

        return "";
    }

    @action.bound
    changeItemsVisibility() {
        this.facilityOrderTemplate.itemsVisible = !this.facilityOrderTemplate.itemsVisible;
    }

    @action.bound
    async reviewTemplate() {
        this.facilityOrderTemplate.facilityOrderTemplateItems = this.facilityOrderTemplate.facilityOrderTemplateItems.filter(fo => fo.productId !== null);

        this.disabledItem = true;
        this.facilityOrderTemplate.isClinicalReviewed = !this.facilityOrderTemplate.isClinicalReviewed;
        if (this.selectedStatusAbrv != "discharge") {
            this.reviewFacilityOrderTemplate();
        }

        var result = await this.pageViewStore.facilityOrderTemplateService.updateNewFlowClinicalTemplate(this.facilityOrderTemplate);
        if (result && result.data && result.data && result.data.isIVPoleItemAdded) {
            this.rootStore.notificationStore.success("IV Pole added to the template.");
        }
        if (this.selectedStatusAbrv == "discharge") {
            this.checkIsEmpty();
        }
        this.disabledItem = false;
        this.pageViewStore.isDropdownOpen = false;
    }

    @action.bound
    async setProductStore(subCategoryId) {
        const ostomySubCategory = this.lookups.subCategory.find((x) => x.abrv == "Ostomy-Products");
        const isOstomySubCategory = subCategoryId === ostomySubCategory.id;

        this.productStore = new BaasicDropdownStore(
            {
                filterable: true,
                textField: "itemId",
            },
            {
                fetchFunc: async (term) => {
                    if ((term && term.trim()) === '')
                        term = undefined;

                    let params = {
                        searchQuery: term,
                        rpp: 50,
                        subCategoryId: subCategoryId,
                        isActive: true,
                        embed: "Product,Product.ItemType,Product.ItemCategory,Product.SubCategory,Product.UnitOfMeasure,Product.ProcedureCode_",
                    };

                    if (isOstomySubCategory) {
                        params = { ...params, sort: "isPreferred|desc" };
                    }

                    const response = await this.pageViewStore.itemSubcategoryService.find(params);
                    let filteredProducts = this.isMasterPatient ? response.data.item : response.data.item.filter((x) => !x.product.itemId.toLowerCase().includes("-cs"));

                    return _.map(filteredProducts, (item) => { return { ...item.product }; });
                },
            }
        );
    }

    @action.bound
    async addEmptyItem() {
        if( this.facilityOrderTemplate.facilityOrderTemplateItems && this.facilityOrderTemplate.facilityOrderTemplateItems.some(i => !i.productId)){
			return;
		}

        await this.setProductStore(this.facilityOrderTemplate.subCategoryId);

        this.facilityOrderTemplate.facilityOrderTemplateItems.push({
            id: uuid(),
            note: null,
            product: null,
            productId: null,
            procedureCode: null,
            mlph: undefined,
            frequency: undefined,
            itemCals: 0,
            itemMls: 0,
            templateQuantity: null,
            orderQuantity: 0,
            importActionId: this.lookups.importAction.find(x => x.abrv === 'insert').id,
            importDetailStatusId: this.lookups.importDetailStatus.find(x => x.abrv === 'new').id,
            facilityOrderTemplateId: this.facilityOrderTemplate.id,
            toggle: true
        });

        this.pageViewStore.isDropdownOpen = true;
    }

    @action.bound
    setItemToggle(facilityOrderTemplateItem) {
        facilityOrderTemplateItem.toggle = false;
    }

    @action.bound
    editItem(facilityOrderTemplateItem, value, propertyName) {
        facilityOrderTemplateItem[propertyName] = value;
        if (propertyName === "templateQuantity") {
            facilityOrderTemplateItem["orderQuantity"] = value
        }
    }

    @action.bound
    async updateItem(facilityOrderTemplateItem, isNote) {

        if (Number.isNaN(facilityOrderTemplateItem.templateQuantity)  || facilityOrderTemplateItem.templateQuantity === '' || facilityOrderTemplateItem.templateQuantity === null || facilityOrderTemplateItem.templateQuantity === undefined) {
            facilityOrderTemplateItem.templateQuantity = 0;
        }
        if (Number.isNaN(facilityOrderTemplateItem.orderQuantity) ||facilityOrderTemplateItem.orderQuantity === '' || facilityOrderTemplateItem.orderQuantity === null || facilityOrderTemplateItem.orderQuantity === undefined) {
            facilityOrderTemplateItem.orderQuantity = 0;
        }

        if (facilityOrderTemplateItem.templateQuantity == facilityOrderTemplateItem.lastTemplateQuantity &&
            facilityOrderTemplateItem.orderQuantity == facilityOrderTemplateItem.lastOrderQuantity &&
            facilityOrderTemplateItem.note == facilityOrderTemplateItem.lastNote) {
            return;
        }

        if (facilityOrderTemplateItem.orderQuantity < facilityOrderTemplateItem.sendSeparatelyQty) {
            this.rootStore.notificationStore.error("An SS has already been applied to this item. The sales order qty cannot be lower than the SS qty.");
            facilityOrderTemplateItem.orderQuantity = facilityOrderTemplateItem.lastOrderQuantity;
            facilityOrderTemplateItem.templateQuantity = facilityOrderTemplateItem.lastTemplateQuantity;
            return;
        }

        this.disabledItem = true;
        const importActionDelete = this.lookups.importAction.find(x => x.abrv === "delete");
        if (facilityOrderTemplateItem.templateItemId && facilityOrderTemplateItem.importActionId != importActionDelete.id) {
            facilityOrderTemplateItem.importAction = this.lookups.importAction.find(x => x.abrv === "update");
            facilityOrderTemplateItem.importActionId = facilityOrderTemplateItem.importAction.id;
        }

        let change = false;
        if (isNote) {
            await this.pageViewStore.facilityOrderTemplateItemService.update(facilityOrderTemplateItem);
            if (facilityOrderTemplateItem.facilityOrderTemplateItemInitial && facilityOrderTemplateItem.note != facilityOrderTemplateItem.facilityOrderTemplateItemInitial.note) {
                if (!facilityOrderTemplateItem.isNoteChanged) {
                    change = true;
                    facilityOrderTemplateItem.isNoteChanged = true;
                }
            }
            else
                facilityOrderTemplateItem.isNoteChanged = false;

            facilityOrderTemplateItem.lastNote = facilityOrderTemplateItem.note;
        }
        else {
            let result = await this.pageViewStore.facilityOrderTemplateItemService.newUpdate(facilityOrderTemplateItem);
            if (result) {
                facilityOrderTemplateItem.orderQuantity = result.orderQuantity;
                facilityOrderTemplateItem.templateQuantity = result.templateQuantity;
                facilityOrderTemplateItem.importActionId = result.importActionId;

                facilityOrderTemplateItem.lastTemplateQuantity = facilityOrderTemplateItem.templateQuantity;
                facilityOrderTemplateItem.lastOrderQuantity = facilityOrderTemplateItem.orderQuantity;
                facilityOrderTemplateItem.lastNote = facilityOrderTemplateItem.note;

                if (facilityOrderTemplateItem.importActionId) {
                    const importAction = this.lookups.importAction.find(x => x.id === facilityOrderTemplateItem.importActionId);
                    facilityOrderTemplateItem.importAction = importAction;
                }
                this.facilityOrderTemplate.isDifferentQty = result.isDifferentQty;
                this.changeFacilityOrderTemplateStatus();

                if (facilityOrderTemplateItem.facilityOrderTemplateItemInitial && result.templateQuantity != facilityOrderTemplateItem.facilityOrderTemplateItemInitial.templateQuantity) {
                    if (!facilityOrderTemplateItem.isTemplateQuantityChanged) {
                        change = true;
                        facilityOrderTemplateItem.isTemplateQuantityChanged = true;
                    }
                }
                else
                    facilityOrderTemplateItem.isTemplateQuantityChanged = false;

                if (facilityOrderTemplateItem.facilityOrderTemplateItemInitial && result.orderQuantity != facilityOrderTemplateItem.facilityOrderTemplateItemInitial.orderQuantity) {
                    if (!facilityOrderTemplateItem.isOrderQuantityChanged) {
                        change = true;
                        facilityOrderTemplateItem.isOrderQuantityChanged = true;
                    }
                }
                else
                    facilityOrderTemplateItem.isOrderQuantityChanged = false;
            }
        }

        if (change) {
            this.isQtyChange = true;
            this.isQtyChange = false;
        }
        this.disabledItem = false;
        this.pageViewStore.isDropdownOpen = false;
    }

    @action.bound
    async addItem(facilityOrderTemplateItems, items, index) {
        facilityOrderTemplateItems.splice(index);
        _.each(items, i => {
            facilityOrderTemplateItems.push({
                id: i.id,
                note: i.note,
                product: i.product,
                productId: i.product.id,
                procedureCode: i.procedureCode,
                mlph: i.mlph,
                frequency: i.frequency,
                itemCals: i.itemCals,
                itemMls: i.itemMls,
                templateQuantity: i.templateQuantity,
                orderQuantity: i.orderQuantity,
                importActionId: i.importActionId,
                importDetailStatusId: i.importDetailStatusId,
                facilityOrderTemplateId: i.facilityOrderTemplateId,
            });
        });
    }

    @action.bound
    async saveItemOnProductSelect(facilityOrderTemplateItem, index, product) {
        this.disabledItem = true;
        try {
            const trachTubeSubCategoryId = this.lookups.subCategory.find(x => x.abrv == 'Trach-Tube').id;
            if (this.facilityOrderTemplate.templateId && this.facilityOrderTemplate.subCategoryId === trachTubeSubCategoryId && this.facilityOrderTemplate.facilityOrderTemplateItems.some(x => x.productId && x.importActionId !== this.deleteImportActionId)) {
                this.rootStore.modalStore.showConfirm('FACILITY_ORDER_TEMPLATE.EDIT.CONFIRM_DELTE_TRACH_TUBE_ITEMS', async () => {
                    await this.saveItem(facilityOrderTemplateItem, index, product, true);
                    this.changeFacilityOrderTemplateStatus();
                });
            }
            else {
                await this.saveItem(facilityOrderTemplateItem, index, product);
                this.changeFacilityOrderTemplateStatus();
            }
            await this.missingDocumentStore.filterAsync();
        } catch (err) {
            this.disabledPatient = false;
            this.rootStore.notificationStore.error(err.data ? err.data : "FACILITY_ORDER_TEMPLATE_ITEM.EDIT.ERROR");
        }
        this.disabledItem = false;
    }

    @action.bound
    async saveItem(facilityOrderTemplateItem, index, product, refreshTemplates = false) {
        if (product) {
            this.disabledPatient = true;
            let tempItem = {
                product: product,
                productId: product.id,
                procedureCode: product.procedureCode_ && product.procedureCode_.abrv,
                importActionId: facilityOrderTemplateItem.importActionId,
                importDetailStatusId: facilityOrderTemplateItem.importDetailStatusId,
                facilityOrderTemplateId: this.facilityOrderTemplate.id,
            };

            const isEnteral = this.lookups.itemCategory.some((i) => i.id === this.facilityOrderTemplate.itemCategoryId && i.abrv.includes("enteral"));
            const itemType = (product.itemType && (product.itemType.abrv === "bottle" || product.itemType.abrv === "can")) || (product.procedureCode_ && product.procedureCode_.abrv === "B4155");
            if (!this.isMasterPatient && isEnteral && itemType) {
                _.extend(tempItem, { itemMls: 1, itemCals: product.calsPerMl });
            }

            const response = await this.pageViewStore.facilityOrderTemplateItemService.createAdditionalItemsNewFlow(
                {
                    facilityOrderId: this.facilityOrder.id,
                    facilityOrderItem: tempItem,
                    facilityOrderItems: this.facilityOrderTemplate.facilityOrderTemplateItems.filter((i) => i.product).map((i) => { return { product: i.product, productId: i.productId, procedureCode: i.procedureCode, importActionId: i.importActionId }; }),
                    subCategoryId: this.facilityOrderTemplate.subCategoryId,
                    clinicalStatusId: this.facilityOrderTemplate.clinicalStatusId,
                    isMasterPatient: this.isMasterPatient
                }
            );

            if (refreshTemplates || (tempItem.product.innerCannulaId && this.facilityOrderTemplate.linkedTemplateId == null)) {
                await this.fetchPatientTemplates();
                this.disabledPatient = false;
                return;
            }

            this.addItem(this.facilityOrderTemplate.facilityOrderTemplateItems, response, index);

            if (!this.isMasterPatient && isEnteral && itemType) {
                index = this.facilityOrderTemplate.facilityOrderTemplateItems.indexOf(this.facilityOrderTemplate.facilityOrderTemplateItems.slice(index).find(i => i.productId == tempItem.productId));
                this.openFacilityOrderTemplateItemNewFlowCalculationModal(this.facilityOrderTemplate.facilityOrderTemplateItems, index);
            }
            this.disabledPatient = false;
        }
        this.pageViewStore.isDropdownOpen = false;
    }

    @action.bound
    async setImportActionToDeleteAndAddItem(item, index) {
        this.disabledPatient = true;
        try {
            if (item.importAction && item.importAction.name === "Delete") {
                await this.setImportAction(item, "update")
            }
            else {
                await this.deleteFacilityOrderTemplateItem(index)
                this.addEmptyItem();
            }
        }
        catch (err) {
            this.rootStore.notificationStore.error("FACILITY_ORDER_TEMPLATE_ITEM.EDIT.DELETE_ERROR");
        }
        this.disabledPatient = false;
    }

    @action.bound
    async deleteTemplate(facilityOrderTemplateId) {
        try {
            await this.pageViewStore.facilityOrderTemplateService.deleteNewTemplate(facilityOrderTemplateId);
            this.removeTemplate(facilityOrderTemplateId);
        } catch (err) {
            this.rootStore.notificationStore.error("Error occurred while trying to delete a template.");
        }
    }

    @action.bound
    async deleteFacilityOrderTemplateItem(index, disabledPatient = false) {
        this.disabledItem = true;
        if (disabledPatient) this.disabledPatient = true;
        if (this.facilityOrderTemplate.facilityOrderTemplateItems[index].templateItemId) {
            await this.setImportAction(this.facilityOrderTemplate.facilityOrderTemplateItems[index], 'delete');
        }
        else {
            if (this.isNewPatient && this.facilityOrderTemplate.facilityOrderTemplateItems.length == 1) {
                let params = { facilityOrderId: this.facilityOrder.id, patientId: this.patient.id, rpp: 2, fields: "id" };
                if (this.facilityOrder.isEnteralWeek) {
                    params = _.extend(params, {
                        itemCategoryIds: [this.lookups.itemCategory.find(x => x.abrv == 'enteral').id]
                    });
                }
                var response = (await this.pageViewStore.facilityOrderTemplateService.find(params)).data.item;
                if (response.length == 1) {
                    this.pageViewStore.facilityOrderTemplateItemNewFlowDeleteQuestionModal.open({
                        deleteItem: () => this.deleteItem(index, false),
                        deletePatient: () => this.deleteItem(index, true)
                    });
                    if (disabledPatient) this.disabledPatient = false;
                    return;
                }
            }
            await this.deleteItem(index, true);
            this.changeFacilityOrderTemplateStatus();
        }

        await this.missingDocumentStore.filterAsync();
        if (disabledPatient) this.disabledPatient = false;
        this.disabledItem = false;
        this.pageViewStore.isDropdownOpen = false;
    }

    @action.bound
    async deleteItem(index, deleteTemplate) {
        const isNewProduct = this.facilityOrderTemplate.facilityOrderTemplateItems[index].product != null;
        if (isNewProduct) {
            const facilityOrderLinkedTemplateId = this.facilityOrderTemplate.linkedTemplateId;
            const isInnerCannula = this.facilityOrderTemplate.facilityOrderTemplateItems[index].product.innerCannulaId != null;

            try {
                await this.pageViewStore.facilityOrderTemplateItemService.newDelete(this.facilityOrderTemplate.facilityOrderTemplateItems[index]);
            } catch (ex) {
                if (ex && ex.data.includes("FK_InventoryCalculationCutback_FacilityOrderTemplateItem")) {
                    this.rootStore.notificationStore.error("Template item cannot be deleted because it is included in the Inventory Calculation.");
                }
                else {
                    this.rootStore.notificationStore.error("An unexpected error occurred while trying to delete the item.");
                }
                return;
            }

            if (facilityOrderLinkedTemplateId && isInnerCannula) {
                this.removeTemplate(facilityOrderLinkedTemplateId);
                this.setLinkedTemplate(this.facilityOrderTemplate.id);
            }
        }
        this.facilityOrderTemplate.facilityOrderTemplateItems.splice(index, 1);
        if (deleteTemplate && this.facilityOrderTemplate.facilityOrderTemplateItems.length === 0) {
            await this.deleteTemplate(this.facilityOrderTemplate.id);
        }

        if (isNewProduct && !(deleteTemplate && this.facilityOrderTemplate.facilityOrderTemplateItems.length === 0)) {
            this.setDifferentQty("IsDifferentQty");
        }
    }

    @action.bound
    async setDifferentQty(embed) {
        const response = await this.pageViewStore.facilityOrderTemplateService.getFacilityOrderTemplateValidation(this.facilityOrderTemplate.id, { embed: embed });
        runInAction(() => {
            if (response && response.data && embed) {
                if (embed.includes('IsDoNotSupply')) {
                    this.facilityOrderTemplate.isDoNotSupply = response.data.isDoNotSupply;
                }
                if (embed.includes('IsDifferentQty')) {
                    this.facilityOrderTemplate.isDifferentQty = response.data.isDifferentQty;
                }
            }
        });
    }

    @action.bound
    async setImportAction(facilityOrderTemplateItem, action) {
        this.disabledItem = true;
        facilityOrderTemplateItem.importAction = this.lookups.importAction.find(x => x.abrv === action);
        facilityOrderTemplateItem.importActionId = facilityOrderTemplateItem.importAction.id;
        await this.pageViewStore.facilityOrderTemplateItemService.update(facilityOrderTemplateItem);
        this.changeFacilityOrderTemplateStatus();
        await this.missingDocumentStore.filterAsync();
        this.disabledItem = false;
    }

    @action.bound
    openFacilityOrderTemplateItemNewFlowCalculationModal(facilityOrderTemplateItems, index) {
        this.pageViewStore.facilityOrderTemplateItemNewFlowCalculationModal.open({
            facilityOrderTemplateItem: facilityOrderTemplateItems[index],
            facilityOrderTemplate: this.facilityOrderTemplate,
            lookups: this.lookups,
            facilityOrderId: this.facilityOrderId,
            isUpdate: true,
            changeFacilityOrderTemplateStatus: () => this.changeFacilityOrderTemplateStatus()
        });
    }

    @action.bound
    openFacilityOrderTemplateMissingDocumentNoteModal(missingDocument) {
        if (this.facilityOrderTemplate.facilityOrderTemplateMissingDocuments.find(x => x.missingDocument.id == missingDocument.id)) {
            this.pageViewStore.facilityOrderTemplateMissingDocumentNoteModal.open({
                missingDocument: _.extend(missingDocument, { facilityOrderTemplateId: this.facilityOrderTemplate.id, facilityOrderTemplateMissingDocumentId: this.facilityOrderTemplate.facilityOrderTemplateMissingDocuments.find(x => x.missingDocument.id == missingDocument.id).id }),
                updateFacilityOrderTempalte: () => this.updateFacilityOrderTempalte("facilityOrderTemplateMissingDocuments", true)
            });
        }
    }

    @action.bound
    async updateFacilityOrderTempalte(propertyName, submit = false) {
        if (submit || this.facilityOrderTemplate[propertyName] != this.form.$(propertyName).value) {
            this.form.submit();
        }
    }

    showChangeTriangels() {
        _.forEach(this.facilityOrderTemplate.facilityOrderTemplateItems, (facilityOrderTemplateItem) => {
            if (facilityOrderTemplateItem.facilityOrderTemplateItemInitial && facilityOrderTemplateItem.templateQuantity != facilityOrderTemplateItem.facilityOrderTemplateItemInitial.templateQuantity) {
                if (!facilityOrderTemplateItem.isTemplateQuantityChanged) {
                    facilityOrderTemplateItem.isTemplateQuantityChanged = true;
                }
            }
            else
                facilityOrderTemplateItem.isTemplateQuantityChanged = false;

            if (facilityOrderTemplateItem.facilityOrderTemplateItemInitial && facilityOrderTemplateItem.orderQuantity != facilityOrderTemplateItem.facilityOrderTemplateItemInitial.orderQuantity) {
                if (!facilityOrderTemplateItem.isOrderQuantityChanged) {
                    facilityOrderTemplateItem.isOrderQuantityChanged = true;
                }
            }
            else
                facilityOrderTemplateItem.isOrderQuantityChanged = false;

            if (facilityOrderTemplateItem.facilityOrderTemplateItemInitial && facilityOrderTemplateItem.note != facilityOrderTemplateItem.facilityOrderTemplateItemInitial.note) {
                if (!facilityOrderTemplateItem.isNoteChanged) {
                    facilityOrderTemplateItem.isNoteChanged = true;
                }
            }
            else
                facilityOrderTemplateItem.isNoteChanged = false;
        });
        this.isQtyChange = true;
        this.isQtyChange = false;
    }

    @action.bound
    async updatePatient() {
        if (!this.actions.updatePatientDetails) return;
        this.disabledItem = true;
        this.form.setFieldsDisabled(true);
        try {
            let resource = { height: this.form.$("height").value, weight: this.form.$("weight").value }
            if (resource.height != this.patient.height || resource.weight != this.patient.weight) {
                await this.actions.updatePatientDetails({
                    patientBrightreeId: this.patient.patientKey,
                    height: resource.height,
                    weight: resource.weight,
                    ssn: this.patient.ssn
                });

                this.patient.height = resource.height;
                this.patient.weight = resource.weight;
                this.initializePatientHeightAndWeight();
            }
            this.disabledItem = false;
            this.form.setFieldsDisabled(false);
            return;
        }
        catch (err) {
            this.disabledItem = false;
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.disabledItem = true;
        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            let isPartialUpdate = resource.clinicalStatusId == this.facilityOrderTemplate.clinicalStatusId;
            if (!isPartialUpdate) {
                var clinicalStatus = this.clinicalStatuses.find(x => x.id == resource.clinicalStatusId);
                var oldClinicalStatus = this.clinicalStatuses.find(x => x.id == this.facilityOrderTemplate.clinicalStatusId);

                if ((clinicalStatus && (clinicalStatus.name == "Covered" || clinicalStatus.name == "Prior Auth Obtained")) &&
                    !(oldClinicalStatus && (oldClinicalStatus.name == "Covered" || oldClinicalStatus.name == "Prior Auth Obtained")) &&
                    (await this.pageViewStore.facilityOrderTemplateService.isIVPoleItemNeeded({ id: this.facilityOrderTemplate.id, isReferenceBillable: true })).data) {
                    this.rootStore.notificationStore.warning("Checking for IV pole.");
                }
            }

            var response = await this.actions.update({
                id: this.id,
                isPartialUpdate: isPartialUpdate,
                ...resource
            });

            this.facilityOrderTemplate.note = response.note;
            this.facilityOrderTemplate.swo = response.swo;
            this.facilityOrderTemplate.dxCode1 = response.dxCode1;
            this.facilityOrderTemplate.dxCode2 = response.dxCode2;
            this.facilityOrderTemplate.dxCode3 = response.dxCode3;
            this.facilityOrderTemplate.dxCode4 = response.dxCode4;
            this.facilityOrderTemplate.dxCode5 = response.dxCode5;
            this.facilityOrderTemplate.dxCode6 = response.dxCode6;
            this.facilityOrderTemplate.dxCode7 = response.dxCode7;
            this.facilityOrderTemplate.dxCode8 = response.dxCode8;
            this.facilityOrderTemplate.facilityOrderTemplateMissingDocuments = response.facilityOrderTemplateMissingDocuments;
            this.facilityOrderTemplate.orderingDoctor = response.orderingDoctor;
            this.facilityOrderTemplate.orderingDoctorId = response.orderingDoctorId;
            this.facilityOrderTemplate.clinicalStatusId = response.clinicalStatusId;
            this.facilityOrderTemplate.clinicalStatusNote = response.clinicalStatusNote;
            this.facilityOrderTemplate.clinicalStatus = response.clinicalStatus;
            this.facilityOrderTemplate.newFlowStatus = response.newFlowStatus;
            this.facilityOrderTemplate.newFlowStatusId = response.newFlowStatusId;
            this.facilityOrderTemplate.newFlowUSIntakeStatus = response.newFlowUSIntakeStatus;
            this.facilityOrderTemplate.newFlowUSIntakeStatusId = response.newFlowUSIntakeStatusId;
            this.missingDocsPreviousValue = this.getMissingDocsPreviousValue();

            if (!isPartialUpdate) {
                this.facilityOrderTemplate.facilityOrderTemplateItems = response.facilityOrderTemplateItems;
                if (response.inactiveReasonId == 16) {
                    this.facilityOrderTemplate.isDoNotSupply = true;
                }
                this.facilityOrderTemplate.inactiveReasonId = response.inactiveReasonId;
                this.setDifferentQty("IsDifferentQty,IsDoNotSupply");
                this.showChangeTriangels();
            }

            this.disabledItem = false;
            this.form.setFieldsDisabled(false);
        }
        catch (err) {
            this.disabledItem = false;
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }

    @action.bound
    async generateStandardWrittenOrder() {
        try {
            var url = `${this.pageViewStore.facilityOrderTemplateService.getStandardWrittenOrderReportUrl(this.facilityOrderTemplate.id)}?contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl}&ttype=${this.rootStore.authStore.token.type}`;
            window.open(url, "_blank")
            this.rootStore.notificationStore.success("Standard Written Order successfully generated.");
        }
        catch (err) {
            this.rootStore.notificationStore.error("Error occurred while trying to generate Standard Written Order.");
        }
    }

    getMissingInformationUrological() {
        return this.facilityOrderTemplate.facilityOrderTemplateItems.some(x =>
            (
                (x.product && x.product.procedureCode_ && (x.product.procedureCode_.abrv === "A4352")) ||
                (x.product && x.product.procedureCode_ && (x.product.procedureCode_.abrv === "A4353")) ||
                (x.product && x.product.procedureCode_ && (x.product.procedureCode_.abrv === "A4351"))
            ) &&
            ((!x.templateQuantity) || (x.templateQuantity == 0) || (x.templateQuantity % 28 != 0))
        );
    }

    @action.bound
    async generateMedicalNecessityForm() {
        try {
            if (this.facilityOrderTemplate.itemCategory.abrv === "enteral" && this.getMissingInformationText()) {
                this.pageViewStore.facilityOrderTemplatePNMissingInformationModal.open({
                    missingInformation: this.getMissingInformationText(),
                    generateMedicalNecessityForm: () => this.openMedicalNecessityWindow()
                });
            }
            else if (this.facilityOrderTemplate.itemCategory.abrv === "urological" && this.getMissingInformationUrological()) {
                this.pageViewStore.facilityOrderTemplatePNMissingInformationModal.open({
                    missingInformation: ["Qty per day (system cannot determine)"],
                    generateMedicalNecessityForm: () => this.openMedicalNecessityWindow()
                });
            }
            else {
                this.openMedicalNecessityWindow();
            }
        }
        catch (err) {
            this.rootStore.notificationStore.error("Error occurred while trying to generate Medical Necessity Form.");
        }
    }

    openMedicalNecessityWindow() {
        var url = `${this.pageViewStore.facilityOrderTemplateService.getMedicalNecessityFormReportUrl(this.facilityOrderTemplate.id)}?contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl}&ttype=${this.rootStore.authStore.token.type}`;
        window.open(url, "_blank")
        this.rootStore.notificationStore.success("Progress Notes document successfully generated.");
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowUSIntakePortalNoteModal() {
        this.pageViewStore.facilityOrderTemplateNewFlowUSIntakePortalNoteModal.open({
            facilityOrderTemplateId: this.facilityOrderTemplate.id,
            refreshPortalNote: (portalNote) => (this.facilityOrderTemplate.portalNote = portalNote),
            isIntakeReviewed: true
        });
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModal() {
        this.pageViewStore.facilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModal.open({
            facilityOrderTemplate: this.facilityOrderTemplate
        });
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal() {
        if (!this.facilityOrderTemplate.missingProduct) {
            await this.pageViewStore.facilityOrderTemplateService.updateMissingProduct({ id: this.facilityOrderTemplate.id });
            this.facilityOrderTemplate.missingProduct = true;
        }

        this.pageViewStore.facilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal.open({
            facilityOrderTemplate: this.facilityOrderTemplate,
        });
    }

    @action.bound
    async markDoNotSupply() {
        await this.pageViewStore.facilityOrderTemplateService.setDoNotSupply(this.facilityOrderTemplate);
        this.facilityOrderTemplate.inactiveReasonId = this.facilityOrderTemplate.inactiveReasonId == 16 ? 0 : 16;
    }

    @action.bound
    async openFacilityOrderTemplateDoNotSupplyModal() {
        this.pageViewStore.facilityOrderTemplateDoNotSupplyModal.open({
            title: `${this.facilityOrderTemplate.inactiveReasonId == 16 ? "Unmark" : "Mark"} As Do Not Supply`,
            description: `Are you sure you want to ${this.facilityOrderTemplate.inactiveReasonId == 16 ? "unmark" : "mark"} this order as Do not supply?`,
            markDoNotSupply: () => this.markDoNotSupply(this.facilityOrderTemplate)
        });
    }

    getMissingInformationText() {
        let isPatientWeightMissing = this.patient && !this.patient.weight;
        let isPatientHeightMissing = this.patient && !this.patient.height;
        let isCalorieAmountMissing = this.facilityOrderTemplate.facilityOrderTemplateItems.some(x => x.product && x.product.itemTypeId && !x.itemCals && x.importActionId != this.lookups.importAction.find(y => y.abrv == 'delete').id);
        let isPatientGenderMissing = this.patient && !this.patient.gender;
        let isMlphMissing = this.facilityOrderTemplate.facilityOrderTemplateItems.some(x => x.product && x.product.itemTypeId && !x.mlph && x.importActionId != this.lookups.importAction.find(y => y.abrv == 'delete').id);

        let missingItems = [];
        if (isPatientWeightMissing) {
            missingItems.push("weight");
        }
        if (isPatientHeightMissing) {
            missingItems.push("height");
        }
        if (isCalorieAmountMissing) {
            missingItems.push("total calories");
        }
        if (isPatientGenderMissing) {
            missingItems.push("gender");
        }
        if (isMlphMissing) {
            missingItems.push("flow rate");
        }
        missingItems.sort();

        if (missingItems.length > 0)
            return missingItems;
        return null;
    }

    @action.bound
    async setNewFlowStatus(
        statusAbrv,
        isReview = false,
        inactiveOptionId = null,
        role = null,
        unreview = false,
        setInactiveReasonAndStatuses = false
    ) {
        this.disabledPatient = true;
        try {
            const status = this.lookups.newFlowStatus.find((s) => s.abrv === statusAbrv);

            await this.pageViewStore.facilityOrderTemplateService.batchUpdate([{
                id: this.facilityOrderTemplate.id,
                inactiveReasonId: statusAbrv === "discharge" ? 58 : inactiveOptionId != null ? inactiveOptionId : this.facilityOrderTemplate.inactiveReasonId,
                isReviewed: unreview ? false : isReview ? isReview : isReview ? this.facilityOrderTemplate.newFlowUSIntakeStatus.abrv === "no-change" ? true : false : this.facilityOrderTemplate.isReviewed,
                newFlowStatusId: statusAbrv === "reviewed-clinical" || role == "insurance" || unreview ? this.facilityOrderTemplate.newFlowStatusId : status.id,
                newFlowStatusUpdatedByUserId: this.rootStore.userStore.user.id,
                newFlowInsuranceStatusId: statusAbrv === "discharge" ? status.id : statusAbrv === "reviewed-clinical" || role == "intake" ? this.facilityOrderTemplate.newFlowInsuranceStatusId : status.id,
                portalNote: this.facilityOrderTemplate.portalNote,
                setInitialEligibility: this.facilityOrderTemplate.setInitialEligibility,
                newFlowUSIntakeStatusId: unreview ? this.facilityOrderTemplate.newFlowStatusId : role === "insurance" ? this.facilityOrderTemplate.newFlowUSIntakeStatusId : status.id,
                setInactiveReason: setInactiveReasonAndStatuses,
                isTemplateStatus: true,
                setStatuses: false,
                setInsuranceStatus: this.selectedStatusAbrv === "discharge" && statusAbrv !== "discharge" ? true : false
            }]);

            await this.fetchPatientTemplates(inactiveOptionId === 58);

        } catch (err) {
            this.rootStore.notificationStore.error("An unexpected error occurred while trying to update the template.", err);
        }
        this.disabledPatient = false;
    }

    @action.bound
    async setTemplateStatus(
        newFlowStatusAbrv,
        inactiveReasonId = null,
        setInactiveReasonAndStatuses = false
    ) {
        this.disabledReview = true;
        await this.setNewFlowStatus(newFlowStatusAbrv, false, inactiveReasonId, "intake", false, setInactiveReasonAndStatuses);
        this.disabledReview = false;
    }

    filterMissingDocumentStore(missingDocuments) {
        let result = missingDocuments;
        if (missingDocuments && missingDocuments.some(m => m)) {
            let facilityOrderTemplateItems = this.facilityOrderTemplate && this.facilityOrderTemplate.facilityOrderTemplateItems;

            const diabeticFormulaSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "diabetic-formula").id;
            const renalFormulaNeproNRSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "renal-formula-nepro-nr").id;
            const renalFormulaSuplenaSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "renal-formula-suplena").id;
            const pulmonaryFormulaSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "pulmonary-formula").id;
            const elementalFormulaSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "elemental-formula").id;
            const proteinSupplementSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "protein-supplement").id;
            const siliconeCatheterSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "silicone-catheter").id;
            const coudeCatheterSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "coude-catheter").id;

            if (!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != this.deleteImportActionId && i.product && i.product.specialtyTypeId == diabeticFormulaSpecialtyTypeId))) {
                result = result.filter(i => i.abrv !== "specialty-product-justification-diabetic");
            }
            if (!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != this.deleteImportActionId && i.product && i.product.specialtyTypeId == renalFormulaNeproNRSpecialtyTypeId))) {
                result = result.filter(i => i.abrv !== "specialty-product-justification-renal-nepro");
            }
            if (!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != this.deleteImportActionId && i.product && i.product.specialtyTypeId == renalFormulaSuplenaSpecialtyTypeId))) {
                result = result.filter(i => i.abrv !== "specialty-product-justification-renal-suplena");
            }
            if (!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != this.deleteImportActionId && i.product && i.product.specialtyTypeId == pulmonaryFormulaSpecialtyTypeId))) {
                result = result.filter(i => i.abrv !== "specialty-product-justification-pulmonary");
            }
            if (!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != this.deleteImportActionId && i.product && i.product.specialtyTypeId == elementalFormulaSpecialtyTypeId))) {
                result = result.filter(i => i.abrv !== "specialty-product-justification-elemental");
            }
            if (!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != this.deleteImportActionId && i.product && i.product.specialtyTypeId == proteinSupplementSpecialtyTypeId))) {
                result = result.filter(i => i.abrv !== "specialty-product-justification-protein-supplement");
            }
            if (!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != this.deleteImportActionId && i.product && i.product.specialtyTypeId == siliconeCatheterSpecialtyTypeId))) {
                result = result.filter(i => i.abrv !== "specialty-product-justification-silicone-catheter");
            }
            if (!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != this.deleteImportActionId && i.product && i.product.specialtyTypeId == coudeCatheterSpecialtyTypeId))) {
                result = result.filter(i => i.abrv !== "specialty-product-justification-coude-catheter");
            }
        }
        return result;
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowUSIntakeTemplateActivationModal() {
        this.pageViewStore.facilityOrderTemplateNewFlowUSIntakeTemplateActivationModal.open({
            facilityOrderTemplate: this.facilityOrderTemplate,
            facilityOrderPatient: this.facilityOrderPatient,
            patient: this.patient,
            fetchPatientTemplates: () => this.fetchPatientTemplates()
        });
    }

    @action.bound
    async hasPatientActiveTemplate() {
        let statusIds = _.map(_.filter(this.lookups.newFlowStatus, s => s.abrv === "change" || s.abrv === "no-change"), (s => { return s.id }));
        let params = {
            pageSize: 1,
            facilityOrderId: this.facilityOrder.id,
            patientId: this.patient.id,
            isReviewed: true,
            fields: "id",
            newFlowInsuranceStatusIds: statusIds.join(",")
        }

        if (this.facilityOrder.isEnteralWeek) {
            params = _.extend(params, {
                itemCategoryIds: [this.lookups.itemCategory.find(x => x.abrv == 'enteral').id]
            });
        }

        const response = await this.pageViewStore.facilityOrderTemplateService.find(params);
        return response.data.item && response.data.item.some(i => i);
    }

    @action.bound
    async activateTemplate() {
        this.disabledReview = true;
        if (this.facilityOrderPatient.eligibilityStatusId != null && (await this.hasPatientActiveTemplate())) {
            await this.pageViewStore.facilityOrderTemplateService.activateFacilityOrderTemplate({ id: this.facilityOrderTemplate.id, facilityOrderPatientId: this.facilityOrderPatient.id, eligibilityStatusId: this.facilityOrderPatient.eligibilityStatusId });
            await this.fetchPatientTemplates();
        }
        else {
            await this.openFacilityOrderTemplateNewFlowUSIntakeTemplateActivationModal();
        }
        this.disabledReview = false;
    }

    async changeFacilityOrderTemplateStatus() {
        if (this.selectedStatusAbrv !== "discharge" && this.facilityOrderTemplate.templateId) {
            let response = await this.pageViewStore.facilityOrderTemplateService.changeTemplateStatus([this.facilityOrderTemplate.id]);
            if (response && response.data && response.data.item && response.data.item[0] && this.facilityOrderTemplate) {
                if (this.facilityOrderTemplate) {
                    this.facilityOrderTemplate.newFlowUSIntakeStatusId = response.data.item[0].newFlowUSIntakeStatusId;
                    this.facilityOrderTemplate.newFlowUSIntakeStatus = this.lookups.newFlowStatus.find((s) => s.id === response.data.item[0].newFlowUSIntakeStatusId);
                    this.facilityOrderTemplate.newFlowStatusId = response.data.item[0].newFlowStatusId;
                    this.facilityOrderTemplate.newFlowStatus = this.lookups.newFlowStatus.find((s) => s.id === response.data.item[0].newFlowStatusId);
                }
            }
        }
        this.isQtyChange = true;
        this.isQtyChange = false;
    }

    @action.bound
    async syncOrderingDoctors() {
        if (this.isSyncInProgress)
            return;

        this.isSyncInProgress = true;
        try {
            await this.pageViewStore.localDoctorService.sync();
            this.rootStore.notificationStore.success("Sync Ordering Doctors successfully done.");
        } catch (err) {
            this.rootStore.notificationStore.error(err && err.data && err.data.errors ? err.data.errors : 'Error occurred while trying to sync ordering doctors.');
        }
        this.isSyncInProgress = false;
    }

    @action.bound
    async generateMedicalNecessityFormAndStandardWrittenOrder() {
        await this.generateMedicalNecessityForm();
        await this.generateStandardWrittenOrder();
    }

    @action.bound
    async setIncludeInDocReqEmailData(e) {
        this.disabledItem = true;
        if (this.facilityOrderTemplate.pastFacilityOrderTemplate.includeInDocReqEmail != e.value) {
            var pastTemplate = (await this.pageViewStore.facilityOrderTemplateService.get(this.facilityOrderTemplate.pastFacilityOrderTemplate.id)).data;
            pastTemplate.includeInDocReqEmail = e.value;
            await this.pageViewStore.facilityOrderTemplateService.update(pastTemplate)
            this.facilityOrderTemplate.pastFacilityOrderTemplate.includeInDocReqEmail = e.value;
        }
        this.disabledItem = false;
    }

    @action.bound
    showDischargesDocReqEmailDataNotification() {
        return this.facilityOrderTemplate && this.facilityOrderTemplate.facilityOrderTemplateInitial &&
            (this.facilityOrderTemplate.facilityOrderTemplateInitial.clinicalStatusId === this.doesNotMeetClinicalStatusId || (this.facilityOrderTemplate.pastFacilityOrderTemplate && this.facilityOrderTemplate.pastFacilityOrderTemplate.facilityOrderTemplateMissingDocuments && this.facilityOrderTemplate.pastFacilityOrderTemplate.facilityOrderTemplateMissingDocuments.length > 0)) &&
            (this.facilityOrderTemplate.facilityOrderTemplateInitial.inactiveReasonId == null || this.facilityOrderTemplate.facilityOrderTemplateInitial.inactiveReasonId == 0);
    }

    @action.bound
    showDocReqEmailDataNotification() {
        return this.facilityOrderTemplate && this.facilityOrderTemplate.facilityOrderTemplateInitial &&
            (this.facilityOrderTemplate.facilityOrderTemplateInitial.clinicalStatusId === this.doesNotMeetClinicalStatusId || (this.facilityOrderTemplate.pastFacilityOrderTemplate && this.facilityOrderTemplate.pastFacilityOrderTemplate.facilityOrderTemplateMissingDocuments && this.facilityOrderTemplate.pastFacilityOrderTemplate.facilityOrderTemplateMissingDocuments.length > 0)) &&
            this.facilityOrderTemplate.facilityOrderTemplateInitial.inactiveReasonId != 16 &&
            (this.facilityOrderTemplate.newFlowStatus.abrv === "change" || (this.facilityOrderPatient && this.facilityOrderPatient.facilityOrderPatientInitial && this.facilityOrderPatient.facilityOrderPatientInitial.eligibilityStatus && this.facilityOrderPatient.facilityOrderPatientInitial.eligibilityStatus.name === "Eligible" && this.facilityOrderPatient.facilityOrderPatientInitial.eligibilityStatusId !== this.facilityOrderPatient.eligibilityStatusId));
    }

    @action.bound
    openPatientMissingDocsPreview() {
        window.open(this.rootStore.routerStore.findRoute("master.app.main.patient-missing-docs.preview").pattern.replace(":id", this.facilityOrderTemplate.patientId))
    }

    @action.bound
    getMissingDocsPreviousValue() {
        if (!this.facilityOrderTemplate.facilityOrderTemplateMissingDocumentInitials || !this.facilityOrderTemplate.facilityOrderTemplateMissingDocumentInitials.some(x => x)) {
            return (!this.facilityOrderTemplate.facilityOrderTemplateMissingDocuments || !this.facilityOrderTemplate.facilityOrderTemplateMissingDocuments.some(x => x)) ? null : "";
        }

        let missingDocuments = _.sortBy(this.facilityOrderTemplate.facilityOrderTemplateMissingDocuments, md => md.missingDocument.name);
        let missingDocumentInitials = _.sortBy(this.facilityOrderTemplate.facilityOrderTemplateMissingDocumentInitials, mdi => mdi.missingDocument.name);

        if (missingDocuments.map(mdi => mdi.missingDocument.name).join(", ") != missingDocumentInitials.map(mdi => mdi.missingDocument.name).join(", ")) {
            return missingDocumentInitials.map(mdi => mdi.missingDocument.name).join(", ");
        }
        return null;
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowDeleteModal() {
        let params = { facilityOrderId: this.facilityOrder.id, patientId: this.facilityOrderTemplate.patientId};
        var response = (await this.pageViewStore.facilityOrderTemplateService.find(params)).data.item;

        this.pageViewStore.facilityOrderTemplateNewFlowDeleteModal.open({
            item: this.facilityOrderTemplate,
            deleteTemplate: () => this.deleteTemplate(this.facilityOrderTemplate.id),
            numberOfTemplates: response.length,
            isNewPatient: this.isNewPatient
        });
    }

    @action.bound
    async importFacilityOrderTemplate() {
        try {
            this.rootStore.notificationStore.success("Importing template to Brightree is in progress.");
            await this.pageViewStore.facilityOrderService.importFacilityOrderNewFlow({ facilityOrderId: this.facilityOrderTemplate.facilityOrderId, patientId: this.facilityOrderTemplate.patientId, facilityOrderTemplateId: this.facilityOrderTemplate.id });
        }
        catch (err) {
            if (err.data && err.data.errors) {
                this.rootStore.notificationStore.error(err.data.errors);
            }
            else {
                this.rootStore.notificationStore.error("Error occurred while trying to import a facility order template.");
            }
        }
    }

    @action.bound
    showItemQuantities(facilityOrderTemplate, show) {
        this.templateExpanded = { id: facilityOrderTemplate.id, expanded: show }
    }

    @action.bound
    async toggleThirdRow() {
        if (!this.thirdRowStoresInitialized) {
            await this.initializeThirdRowStores();
            this.itemInitialized = true;
        }

        this.showThirdRow = !this.showThirdRow;
    }

    async initializeThirdRowStores() {
        this.dxCode1Store = this.createDxCodeDropdownStore("dxCode1");
        this.dxCode2Store = this.createDxCodeDropdownStore("dxCode2");
        this.dxCode3Store = this.createDxCodeDropdownStore("dxCode3");
        this.dxCode4Store = this.createDxCodeDropdownStore("dxCode4");
        this.dxCode5Store = this.createDxCodeDropdownStore("dxCode5");
        this.dxCode6Store = this.createDxCodeDropdownStore("dxCode6");
        this.dxCode7Store = this.createDxCodeDropdownStore("dxCode7");
        this.dxCode8Store = this.createDxCodeDropdownStore("dxCode8");

        this.doctorStore = new BaasicDropdownStore({
            textField: 'orderingDoctor',
            filterable: true,
            returnObject: true,
        }, {
            fetchFunc: async (term) => {
                let response;
                if (!this.itemInitialized && this.facilityOrderTemplate.orderingDoctor && this.facilityOrderTemplate.orderingDoctor.npi) {
                    response = { item: [this.facilityOrderTemplate.orderingDoctor] };
                }
                else if (!term)
                    return [];
                else {
                    response = (await this.pageViewStore.localDoctorService.find({ searchQuery: term, rpp: 20 })).data;
                }
                _.extend(response,
                    {
                        item: _.map(response.item, (item => {
                            return _.extend(
                                item, {
                                orderingDoctor: item.name + " - " + item.npi,
                            }
                            );
                        }))
                    }
                );

                return response.item;
            },
            onChange: async () => {
                await this.updateFacilityOrderTempalte("orderingDoctorId", true);
            }
        });

        await this.setDefaultStoreValue();

        this.thirdRowStoresInitialized = true;
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowInvoiceNoteModal() {
        this.pageViewStore.facilityOrderTemplateNewFlowInvoiceNoteModal.open({
            facilityOrderTemplate: this.facilityOrderTemplate
        });
    }
}

export default FacilityOrderTemplateNewFlowClinicalEditViewStore;
